import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'

import {
  ICreateDirectConversationRequestInterfaces,
} from '@toolify/server/src/controllers/ChatController/validators/CreateDirectConversation/types/ICreateDirectConversationRequestInterfaces'
import {
  IAddMembersToDirectConversationRequestInterfaces,
} from '@toolify/server/src/controllers/ChatController/validators/AddMembersToDirectConversation/types/IAddMembersToDirectConversationRequestInterfaces'
import {IEntity} from '@toolify/server/src/services/EntityService/types/IEntity'
import {
  IGetDirectConversationRequestInterfaces,
} from '@toolify/server/src/controllers/ChatController/validators/GetDirectConversation/types/IGetDirectConversationRequestInterfaces'
import {
  mapDirectConversationResponseInstance,
} from '@toolify/client/src/modules/api/singletons/mapDirectConversationResponseInstance'
import {
  IGetDirectConversationsRequestInterfaces,
} from '@toolify/server/src/controllers/ChatController/validators/GetDirectConversations/types/IGetDirectConversationsRequestInterfaces'

export const useDirectConversationApiStore = defineStore('directConversationApiStore', {
  actions: {
    async createDirectConversation(
      entities: IEntity[],
      options: Pick<ICreateDirectConversationRequestInterfaces['body'], 'forceNew'> = {},
    ): Promise<ICreateDirectConversationRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {directConversation} = await apiRequestStore.post<ICreateDirectConversationRequestInterfaces>('/direct-conversation', {
        data: {
          entities,
          forceNew: options.forceNew,
        },
      })
      return {
        directConversation: mapDirectConversationResponseInstance(directConversation),
      }
    },

    async getDirectConversation(
      directConversationId: string,
    ): Promise<IGetDirectConversationRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {directConversation} = await apiRequestStore.get<IGetDirectConversationRequestInterfaces>(`/direct-conversation/${directConversationId}`)
      return {
        directConversation: mapDirectConversationResponseInstance(directConversation),
      }
    },

    async getDirectConversations(): Promise<IGetDirectConversationsRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {directConversations} = await apiRequestStore.get<IGetDirectConversationsRequestInterfaces>('/direct-conversations')
      return {
        directConversations: directConversations.map(directConversation => {
          return mapDirectConversationResponseInstance(directConversation)
        }),
      }
    },

    async updateDirectConversationName(
      directConversationId: string,
      name: string,
    ): Promise<void> {
      const apiRequestStore = useApiRequestStore()
      await apiRequestStore.put(`/direct-conversation/${directConversationId}/name`, {
        data: {
          name,
        },
      })
    },

    async addMembersToDirectConversation(
      directConversationId: string,
      entities: IEntity[],
    ): Promise<IAddMembersToDirectConversationRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const {directConversation} = await apiRequestStore.post<IAddMembersToDirectConversationRequestInterfaces>(
        `/direct-conversation/${directConversationId}/members`,
        {
          data: {
            entities,
          },
        },
      )
      return {
        directConversation: mapDirectConversationResponseInstance(directConversation),
      }
    },
  },
})
